import React from 'react';
import { MessageSquare, Layout, Code, Rocket, ArrowRight } from 'lucide-react';
import { processSteps } from '../mock';

const iconMap = {
  MessageSquare,
  Layout,
  Code,
  Rocket
};

const OurProcess = () => {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="process" className="py-20 px-4" style={{ background: 'var(--bg-page)' }}>
      <div className="max-w-6xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="heading-2 mb-4">Our Process</h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)' }}>
            Simple 4-step process to get your business online
          </p>
        </div>

        {/* Process Steps */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {processSteps.map((step, index) => {
            const Icon = iconMap[step.icon];
            return (
              <div key={step.id} className="relative">
                {/* Step Card */}
                <div className="bg-[var(--bg-card)] border border-[var(--border-light)] rounded-xl p-6 text-center transition-all duration-300 hover:shadow-lg hover:-translate-y-1 h-full">
                  {/* Step Number */}
                  <div
                    className="w-12 h-12 rounded-full flex items-center justify-center mx-auto mb-4 text-white font-bold text-lg"
                    style={{ background: 'var(--gradient-button)' }}
                  >
                    {step.id}
                  </div>

                  {/* Icon */}
                  <div
                    className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4"
                    style={{ background: 'var(--accent-wash)' }}
                  >
                    <Icon size={32} style={{ color: 'var(--accent-text)' }} />
                  </div>

                  {/* Title */}
                  <h3 className="heading-3 mb-3">{step.title}</h3>

                  {/* Description */}
                  <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                    {step.description}
                  </p>
                </div>

                {/* Arrow for desktop */}
                {index < processSteps.length - 1 && (
                  <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                    <ArrowRight size={24} style={{ color: 'var(--accent-text)' }} />
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="text-center">
          <p className="body-large mb-6" style={{ color: 'var(--text-secondary)' }}>
            Ready to get started? Let's discuss your project!
          </p>
          <button onClick={scrollToContact} className="btn-primary">
            Start Your Project Now
          </button>
        </div>
      </div>
    </section>
  );
};

export default OurProcess;
